import React from 'react';
import { AlertCircleIcon } from 'lucide-react';
import { SectionCta } from '../SectionCta';
import { problemList } from '../../data/content';
export function Problem() {
  return <section className="bg-mist-50 px-4 py-16 md:px-8 md:py-24" data-id="element-282" data-mp="2ro5726ieitij">
      <div className="mx-auto max-w-3xl" data-id="element-283" data-mp="2rmakyove8vcv">
        <h2 className="text-center text-[28px] font-extrabold leading-tight tracking-tight text-ink-900 md:text-4xl" data-id="element-284" data-mp="2mptz61bo2t2y">
          The problem isn't always knowing what to look for.
          <span className="mt-2 block text-brand-700" data-id="element-285" data-mp="2cr4fq444h0kl">It's organizing everything into one defensible clinical decision.</span>
        </h2>

        <div className="mt-10 space-y-3 border-l-4 border-brand-500 pl-5 text-[18px] font-semibold leading-relaxed text-ink-800" data-id="element-286" data-mp="28qkfgro95gu8">
          <p data-id="element-287" data-mp="23sakah2j2g8m">A previously treated tooth presents with persistent symptoms.</p>
          <p data-id="element-288" data-mp="6wv16dule6wq">The radiograph raises questions.</p>
          <p data-id="element-289" data-mp="1z35r9uqo2ns">The previous treatment history is incomplete.</p>
          <p data-id="element-290" data-mp="1zmi8b1mdyuf">Several management options may be reasonable.</p>
        </div>

        <p className="mt-8 text-[17px] leading-relaxed text-mist-600" data-id="element-291" data-mp="14a0lxz3kzb00">
          And suddenly, what should be a structured assessment becomes a complicated process of reviewing findings,
          considering alternatives, and documenting clinical reasoning.
        </p>
        <p className="mt-6 text-2xl font-extrabold text-ink-900" data-id="element-292" data-mp="10973hl8wqoei">Sound familiar?</p>
        <p className="mt-4 text-[17px] leading-relaxed text-mist-600" data-id="element-293" data-mp="1nz1bnpia7osf">
          You may already understand the relevant clinical principles. But translating multiple findings into an
          organized assessment and treatment-planning workflow can still be challenging. Especially when you're managing:
        </p>

        <ul className="mt-6 divide-y divide-mist-200 rounded-2xl bg-white ring-1 ring-mist-200" data-id="element-294" data-mp="1j7t12q57txdo">
          {problemList.map(p => <li key={p} className="flex items-start gap-3 px-5 py-4 text-[16px] font-medium text-ink-800" data-id="element-295" data-mp="26wcaj9004g7c">
              <AlertCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" aria-hidden="true" data-id="element-296" data-mp="2bq6tubbp2t5w" />
              {p}
            </li>)}
        </ul>

        <div className="mt-10 rounded-2xl bg-ink-900 p-6 text-center text-white md:p-8" data-id="element-297" data-mp="2gl9hcelsb38h">
          <p className="text-[17px] text-mist-200" data-id="element-298" data-mp="2blwv9w2qm06y">The solution isn't another theoretical endodontics textbook.</p>
          <p className="mt-2 text-xl font-extrabold leading-snug md:text-2xl" data-id="element-299" data-mp="26o4ra3otinme">
            It's a structured system that helps you organize the information{' '}
            <span className="text-cta-400" data-id="element-300" data-mp="1xv1iw9t150ym">you already know how to evaluate.</span>
          </p>
        </div>

        <SectionCta label="I'm ready to organize my next case" data-id="element-301" data-mp="1svoxltht41y5" />
      </div>
    </section>;
}